import React, { Component } from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import { BrowserRouter, Route, Switch ,Redirect,withRouter } from 'react-router-dom';
import Error from "./containers/Error/index";
import { createBrowserHistory } from 'history';
import VisibilitySensor from "react-visibility-sensor";
import { CircularProgressbarWithChildren  } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { Suspense, lazy } from 'react';
const history = createBrowserHistory({forceRefresh: true});
const Authentication = lazy(()=>import("./containers/Home")); 
const Home = lazy(()=>import("./containers/Home"));
const IsolatedCryodexList = lazy(()=>import("./containers/IsolatedCryodexList"));
const IsolatedInfodexList = lazy(()=>import("./containers/IsolatedInfodexList"));
const GroupedInfodex = lazy(()=>import("./containers/GroupedInfodex"));
const CryodexProfile = lazy(()=>import("./containers/Home/profile"));
const Profile  = lazy(()=>import("./containers/Home/profile"));
const EditCryodex = lazy(()=>import("./containers/EditCryodex"));
const Mailbox = lazy(()=>import("./containers/Mailbox"));
const Settings = lazy(()=>import("./containers/Settings"));
const FavouredInfodex = lazy(()=>import("./containers/IsolatedInfodex"));


class App extends Component {
	constructor(props) {
      super(props);      
    }

  render() {
    return (
      <div >	  
        <BrowserRouter>
           <Suspense fallback={<div>		   
		    <VisibilitySensor>
            {({ isVisible }) => {
              const percentage = isVisible ? 100 : 0;
              return (
               <div>				 
					<div style={{height: '100%',textAlign:'center'}}>
					<img style={{ width: 100, marginTop: 140, textAlign:'center' }} src="https://shizzniz.com/images/loader-white.gif" alt="Shizzniz" />				 
						<br/>
						<br/>
						<p style={{color:'red'}}>  90%</p>
					</div>
				</div>
				
              );
            }}
          </VisibilitySensor>
		   </div>}>
            <Switch>
             <Route path="/" component={withRouter (Home)} exact  />    
			 <Route path="/home" component={withRouter(Home)} exact/> 	
			 <Route path="/grouped/infodex" component={withRouter(GroupedInfodex)} exact/> 
			  <Route path="/Isolated/infodex" component={withRouter (FavouredInfodex)} exact/>			 
              <Route path="/isolated/cryodexes/list" component={withRouter (IsolatedCryodexList)} exact/>
              <Route path="/isolated/infodexes/list" component={withRouter (IsolatedInfodexList)} exact/>
              <Route path="/cryodex/profile" component={withRouter (CryodexProfile)} exact/>
              <Route path="/cryodex/profile/:id/edit" component={withRouter (EditCryodex)} exact />              
              <Route path="/cryodex/profile" component={withRouter (CryodexProfile)} exact/>
              <Route path="/cryodex/profile/view" component={withRouter (Profile)} exact/>
              <Route path="/mailbox/:id/" component={withRouter (Mailbox)} exact/>
              <Route path="/settings" component={withRouter (Settings)} exact/>				 
             <Route component={Error} />
            </Switch>
         </Suspense>
        </BrowserRouter>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
  };
};

function matchDispatchToProps(dispatch) {
  return bindActionCreators({          
          },
          dispatch)
}

export default connect(mapStateToProps ,matchDispatchToProps)(App);